var $dad545c909cfec2d$exports = {};
const $dad545c909cfec2d$var$initialState = {
    generations: {},
    selectedGenerations: [],
    pokemon: [],
    selectedPokemon: null,
    guessedPokemon: null,
    status: "ready",
    correctGuessesStreak: 0,
    gameTimeout: null
};
let $dad545c909cfec2d$var$state = {
    ...$dad545c909cfec2d$var$initialState
};
const $dad545c909cfec2d$var$randomNumUpTo = (max)=>Math.floor(Math.random() * (max + 1));
const $dad545c909cfec2d$var$updateGameStatus = (status)=>{
    $dad545c909cfec2d$var$state.status = status;
    const gameContainer = document.getElementById("gameContainer");
    gameContainer.className = status;
};
const $dad545c909cfec2d$var$resetHTML = ()=>{
    const guessingOptionsEl = document.getElementById("guessingOptions");
    guessingOptionsEl.innerHTML = "";
    const answerEl = document.getElementById("answer");
    answerEl.innerText = "";
    const pokemonImage = document.querySelector(".pokemon-image");
    if (pokemonImage) pokemonImage.remove();
};
const $dad545c909cfec2d$var$finishGame = ()=>{
    const { selectedPokemon: selectedPokemon, guessedPokemon: guessedPokemon } = $dad545c909cfec2d$var$state;
    const didNotGuess = !guessedPokemon;
    const guessedCorrectly = selectedPokemon?.id === guessedPokemon?.id && !didNotGuess;
    const { name: name } = selectedPokemon;
    const answerEl = document.getElementById("answer");
    answerEl.innerText = `It's ${name}!`;
    const correctGuessesStreakEl = document.getElementById("streakCount");
    if (guessedCorrectly) $dad545c909cfec2d$var$state.correctGuessesStreak++;
    else $dad545c909cfec2d$var$state.correctGuessesStreak = 0;
    correctGuessesStreakEl.innerText = $dad545c909cfec2d$var$state.correctGuessesStreak;
    const { generations: generations, selectedGenerations: selectedGenerations, pokemon: initialPokemon, correctGuessesStreak: correctGuessesStreak, ...restInitialState } = $dad545c909cfec2d$var$initialState;
    $dad545c909cfec2d$var$state = {
        ...$dad545c909cfec2d$var$state,
        ...restInitialState
    };
    $dad545c909cfec2d$var$updateGameStatus("viewing-result");
    $dad545c909cfec2d$var$state.gameTimeout = setTimeout($dad545c909cfec2d$var$startGame, 3000);
};
const $dad545c909cfec2d$var$beginGuessing = ()=>{
    $dad545c909cfec2d$var$updateGameStatus("guessing");
    const { pokemon: pokemon, selectedPokemon: selectedPokemon } = $dad545c909cfec2d$var$state;
    const pokemonIndexMax = pokemon.length - 1;
    const numOfOtherOptions = 3;
    let guessingOptions = [
        ...Array(numOfOtherOptions)
    ].map(()=>pokemon[$dad545c909cfec2d$var$randomNumUpTo(pokemonIndexMax)]);
    guessingOptions.splice($dad545c909cfec2d$var$randomNumUpTo(numOfOtherOptions), 0, selectedPokemon);
    const gameTimeout = setTimeout($dad545c909cfec2d$var$finishGame, 3000);
    $dad545c909cfec2d$var$state.gameTimeout = gameTimeout;
    const guessingOptionsEl = document.getElementById("guessingOptions");
    guessingOptions.forEach((pokemonOption)=>{
        const { name: name } = pokemonOption;
        const pokemonOptionEl = document.createElement("li");
        pokemonOptionEl.innerText = name;
        pokemonOptionEl.addEventListener("click", ()=>{
            clearTimeout(gameTimeout);
            $dad545c909cfec2d$var$state.guessedPokemon = pokemonOption;
            $dad545c909cfec2d$var$finishGame();
        });
        guessingOptionsEl.appendChild(pokemonOptionEl);
    });
};
const $dad545c909cfec2d$var$setupRandomPokemon = ()=>{
    const selectedPokemon = $dad545c909cfec2d$var$state.pokemon[$dad545c909cfec2d$var$randomNumUpTo($dad545c909cfec2d$var$state.pokemon.length - 1)];
    $dad545c909cfec2d$var$state.selectedPokemon = selectedPokemon;
    const { avatarUrl: avatarUrl } = selectedPokemon;
    const pokemonBoxEl = document.getElementById("pokemonBox");
    const pokemonImage = document.createElement("img");
    pokemonImage.src = avatarUrl;
    pokemonImage.className = "pokemon-image";
    pokemonBoxEl.appendChild(pokemonImage);
};
const $dad545c909cfec2d$var$startGame = ()=>{
    $dad545c909cfec2d$var$resetHTML();
    $dad545c909cfec2d$var$setupRandomPokemon();
    $dad545c909cfec2d$var$beginGuessing();
};
const $dad545c909cfec2d$var$init = async ()=>{
    const pokemonAPIResponse = await fetch("https://beta.pokeapi.co/graphql/v1beta", {
        method: "POST",
        body: JSON.stringify({
            query: `
          query samplePokeAPIquery {
              generations: pokemon_v2_generation {
              name
              pokemon_species: pokemon_v2_pokemonspecies {
                id
                name
              }
            }
          }`
        })
    }).then((res)=>res.json()).catch((error)=>{
        console.log(error);
    });
    const { data: { generations: generations } } = pokemonAPIResponse;
    $dad545c909cfec2d$var$state.generations = generations.reduce((a, { name: name, pokemon_species: pokemon })=>({
            ...a,
            [name]: pokemon.map(({ name: name, id: id })=>{
                const avatarUrl = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`;
                return {
                    id: id,
                    name: name,
                    avatarUrl: avatarUrl
                };
            })
        }), {});
    const generationNames = Object.keys($dad545c909cfec2d$var$state.generations);
    $dad545c909cfec2d$var$state.selectedGenerations = [
        generationNames[0]
    ];
    let pokemon = [].concat(...$dad545c909cfec2d$var$state.selectedGenerations.map((selectedGeneration)=>$dad545c909cfec2d$var$state.generations[selectedGeneration]));
    $dad545c909cfec2d$var$state.pokemon = pokemon;
    const generationOptionsEl = document.getElementById("generationOptions");
    generationNames.forEach((generationName, i)=>{
        const generationOptionEl = document.createElement("li");
        generationOptionEl.innerText = generationName.split("-")[1];
        if (i === 0) generationOptionEl.className = "active";
        generationOptionEl.addEventListener("click", (e)=>{
            const isRemoving = $dad545c909cfec2d$var$state.selectedGenerations.includes(generationName);
            if ($dad545c909cfec2d$var$state.selectedGenerations.length < 2 && isRemoving) return;
            e.target.classList.toggle("active");
            $dad545c909cfec2d$var$state.selectedGenerations = isRemoving ? $dad545c909cfec2d$var$state.selectedGenerations.filter((selectedGeneration)=>selectedGeneration !== generationName) : [
                ...$dad545c909cfec2d$var$state.selectedGenerations,
                generationName
            ];
            $dad545c909cfec2d$var$state.pokemon = [].concat(...$dad545c909cfec2d$var$state.selectedGenerations.map((generationName)=>$dad545c909cfec2d$var$state.generations[generationName]));
            clearTimeout($dad545c909cfec2d$var$state.gameTimeout);
            $dad545c909cfec2d$var$startGame();
        });
        generationOptionsEl.appendChild(generationOptionEl);
    });
    const startGameButtonEl = document.getElementById("startGameButton");
    startGameButtonEl.addEventListener("click", $dad545c909cfec2d$var$startGame);
    $dad545c909cfec2d$var$updateGameStatus("ready");
};
// Call our initialization of the application
$dad545c909cfec2d$var$init();


//# sourceMappingURL=index.3b7d60c5.js.map
